<template>
  <MainLayout>
    <b-row id="criterionOverview">
      <b-col class="shadow-sm">
        <b-card-body>
          <criterion-overview />
        </b-card-body>
      </b-col>
    </b-row>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import CriterionOverview from "@/components/criterion/CriterionOverview.vue";

export default {
  components: {
    MainLayout,
    CriterionOverview,
  },
};
</script>

<style>
#criterionManagmenentContainer .v-list__tile--disabled {
  color: black;
}
#criterionManagmenentContainer .theme--light.v-list .v-list__tile--link:hover {
  background-color: transparent;
  cursor: pointer;
}
</style>

<style scoped>
.structureTitle {
  padding-left: 0px;
}
.structureSubTitle {
  padding-left: 10px;
}
.structureCriterion {
  padding-left: 20px;
}

.selectedItem {
  background-color: rgba(0, 0, 0, 0.04);
}
.structureCriterion:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.structureTitle .v-list__tile__title {
  font-size: 19px;
  font-weight: bold;
}
.structureSubTitle .v-list__tile__title {
  font-size: 16px;
  font-weight: bold;
}
.structureCriterion .v-list__tile__title {
  font-size: 14px;
}
.criterionSelectionList {
  height: 500px;
  overflow: auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
